import { useMutation } from "@apollo/client"
import { CreateMockIntegrationSourceDocument } from "@hydrologiq/gql-experience/graphql"
import { usePrimaryClientIfAvailable } from "../../providers/DualGraphQLProvider"

export const useCreateMockIntegrationSource = () => {
  const client = usePrimaryClientIfAvailable()
  const [createMockSource, { loading, error }] = useMutation(CreateMockIntegrationSourceDocument, { client })

  return {
    createMockSource,
    loading,
    error,
  }
}
